// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** Assignment list View ****/
sorry #assignmentCourseList {
  margin-top: 2rem;
}

/* Override this to bootstrap default */
.users #assignmentCourseList.row .row {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 0;
  margin-bottom: 0;
}

/* Assignment layout */
#assignmentCourseList .assignment .tiles {
  padding: inherit;
}
#assignmentCourseList .assignment .info {
  display: flex;
  align-items: flex-start;
}

#assignmentCourseList .assignment {
  border-top: 1px solid #e5e5e5;
  padding: inherit;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

#assignmentCourseList .assignment:first-child {
  border-top: none;
  padding-top: 0rem;
  padding-bottom: 2rem;
}

#assignmentCourseList .assignment:last-child {
  margin-bottom: 5rem;
  border-bottom: 1px solid #e5e5e5;
}

/* Assignment image */
#assignmentCourseList .imageDate {
  padding-right: 0;
}
#assignmentCourseList .imageDate .mainImg {
  width: 100%;
}

/* The date the course is due */
#assignmentCourseList .dateHolder .date {
  font-weight: bold;
  font-size: 14px;
  padding-left: 2.5rem;
  padding-bottom: 1.5rem;
  display: block;
}

/* Assignment status styling */
#assignmentCourseList .title .status {
  font-size: 14px;
  padding-bottom: 0.5rem;
  display: block;
}

/* The course title */
#assignmentCourseList .title h3 {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 16px;
}

/* The course meta id/type/etc */
#assignmentCourseList .courseMeta {
  display: flex;
  justify-content: flex-begin;
  flex-direction: row;
  font-size: 14px;
  padding-top: 0.1rem;
  flex-wrap: wrap;
}
/* Pipe bars between course meta items*/
#assignmentCourseList .courseMeta span:nth-last-child(n + 2):after {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

/* The course meta id/type/etc */
#assignmentCourseList .courseMetaManager {
  display: flex;
  justify-content: flex-begin;
  flex-direction: row;
  font-size: 14px;
  padding-top: 0.1rem;
}
/* Pipe bars between course meta items*/
#assignmentCourseList .courseMetaSpan:nth-last-child(n + 2):after {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

#assignmentCourseList .viewCourses {
  color: #505050;
  cursor: pointer;
  font-size: 16px;
  text-decoration: underline;
  vertical-align: bottom;
}

/* Course description */
.description {
  font-size: 14px;
  margin-bottom: 0;
}
/* Make the short version of the description have a line wrapping.
 *This is inside a div because the content is rendered
 * using ng-bind-html
 */
.description.short {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/********************* ALL THAT FOLLOWS IS COMMON ACROSS OTHER PAGES.
 * Ignore unless you aren't working on the assignment course list page.
 */

.list {
  margin-top: 15px;
}

.list .col-md-12 {
  margin-bottom: 7px;
  overflow: hidden;
  padding: 0px;
}

.list .col-md-12.even {
  background-color: #f2f2f2;
}

.list .col-md-12 .info .imageDate {
  cursor: pointer;
  float: left;
  margin-right: 15px;
  overflow: hidden;
  padding: 0px;
  position: relative;
  width: 250px;
}

.list .col-md-12 .info .imageDate .dateHolder {
  background-color: #1eabe3;
  color: #fff;
  font-weight: bold;
  padding: 7px;
  width: 250px;
}

.list .col-md-12 .info .imageDate .dateHolder .time {
  float: right;
}

.list .col-md-12 .info .imageDate .mainImg {
  background-color: #bbb;
  float: left;
  margin-right: 15px;
  width: 250px;
}

.list .col-md-12 .info .title {
  padding-top: 7px;
  position: relative;
}

.list .col-md-12 .info .title h3 {
  margin: 0px 0px 7px;
  padding-top: 3px;
  position: relative;
}

.list .col-md-12 .info .title .more {
  float: right;
  padding: 7px;
}

.list .col-md-12.alert {
  margin-bottom: 20px;
  padding: 15px;
}

.actionHolder {
  margin-top: 1rem;
  overflow: hidden;
  width: 100%;
}

/*
* Spinner for all launch buttons on the list, outside of the slide down.
*/
.actionHolder .spinner {
  float: left;
  margin: 16px 45px 16px 62px;
}

/* more link */
.actionHolder .more {
  float: left;
  font-size: 14px;
  margin-top: 10px;
}

/*Start Manager list view */

#assignmentCourseList .description.long {
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
}

/* action button css */
#assignmentCourseList .remove {
  font-size: 14px;
  color: black;
  text-decoration: underline;
}

/* action button css */
#assignmentCourseList .removeInactive {
  font-size: 14px;
  color: lightgrey;
  cursor: default;
}

/* action button css */
#assignmentCourseList .removeInactive:hover {
  cursor: default;
}

#assignmentCourseList .edit {
  margin-left: 0px;
  float: left;
  padding-left: 2px;
  cursor: pointer;
}

#assignmentCourseList .assignmentActions {
  display: flex;
  margin: 0px 0px;
}

#assignmentCourseList .managerDate {
  float: left;
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 1.5rem;
  padding-right: 2.5rem;
}

#assignmentCourseList .managerDatePicker {
  /*width: 250px;*/
  margin-bottom: 10px;
}

#assignmentCourseList .btn-default {
  float: left;
  margin-right: 15px;
}

#assignmentCourseList .hideOnListPages {
  display: none;
}

#assignmentCourseList .slideDownMeta {
  padding-top: 0rem !important;
}

#assignmentCourseList .courseGroupIcon {
  margin-left: 2rem !important;
}

/* View Resources start */
.launchBtnResources {
  margin-right: 4px !important;
}

#assignmentCourseList #viewResources .body {
  overflow: hidden;
  padding: 5px;
  padding-left: 10px;
}

/* View Resources end */
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/list.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE;AACF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;CAEC;AACD;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;;AAE3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uBAAuB","sourcesContent":["/**** Assignment list View ****/\nsorry #assignmentCourseList {\n  margin-top: 2rem;\n}\n\n/* Override this to bootstrap default */\n.users #assignmentCourseList.row .row {\n  margin-left: -15px;\n  margin-right: -15px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n/* Assignment layout */\n#assignmentCourseList .assignment .tiles {\n  padding: inherit;\n}\n#assignmentCourseList .assignment .info {\n  display: flex;\n  align-items: flex-start;\n}\n\n#assignmentCourseList .assignment {\n  border-top: 1px solid #e5e5e5;\n  padding: inherit;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n#assignmentCourseList .assignment:first-child {\n  border-top: none;\n  padding-top: 0rem;\n  padding-bottom: 2rem;\n}\n\n#assignmentCourseList .assignment:last-child {\n  margin-bottom: 5rem;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n/* Assignment image */\n#assignmentCourseList .imageDate {\n  padding-right: 0;\n}\n#assignmentCourseList .imageDate .mainImg {\n  width: 100%;\n}\n\n/* The date the course is due */\n#assignmentCourseList .dateHolder .date {\n  font-weight: bold;\n  font-size: 14px;\n  padding-left: 2.5rem;\n  padding-bottom: 1.5rem;\n  display: block;\n}\n\n/* Assignment status styling */\n#assignmentCourseList .title .status {\n  font-size: 14px;\n  padding-bottom: 0.5rem;\n  display: block;\n}\n\n/* The course title */\n#assignmentCourseList .title h3 {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n/* The course meta id/type/etc */\n#assignmentCourseList .courseMeta {\n  display: flex;\n  justify-content: flex-begin;\n  flex-direction: row;\n  font-size: 14px;\n  padding-top: 0.1rem;\n  flex-wrap: wrap;\n}\n/* Pipe bars between course meta items*/\n#assignmentCourseList .courseMeta span:nth-last-child(n + 2):after {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\n/* The course meta id/type/etc */\n#assignmentCourseList .courseMetaManager {\n  display: flex;\n  justify-content: flex-begin;\n  flex-direction: row;\n  font-size: 14px;\n  padding-top: 0.1rem;\n}\n/* Pipe bars between course meta items*/\n#assignmentCourseList .courseMetaSpan:nth-last-child(n + 2):after {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\n#assignmentCourseList .viewCourses {\n  color: #505050;\n  cursor: pointer;\n  font-size: 16px;\n  text-decoration: underline;\n  vertical-align: bottom;\n}\n\n/* Course description */\n.description {\n  font-size: 14px;\n  margin-bottom: 0;\n}\n/* Make the short version of the description have a line wrapping.\n *This is inside a div because the content is rendered\n * using ng-bind-html\n */\n.description.short {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/********************* ALL THAT FOLLOWS IS COMMON ACROSS OTHER PAGES.\n * Ignore unless you aren't working on the assignment course list page.\n */\n\n.list {\n  margin-top: 15px;\n}\n\n.list .col-md-12 {\n  margin-bottom: 7px;\n  overflow: hidden;\n  padding: 0px;\n}\n\n.list .col-md-12.even {\n  background-color: #f2f2f2;\n}\n\n.list .col-md-12 .info .imageDate {\n  cursor: pointer;\n  float: left;\n  margin-right: 15px;\n  overflow: hidden;\n  padding: 0px;\n  position: relative;\n  width: 250px;\n}\n\n.list .col-md-12 .info .imageDate .dateHolder {\n  background-color: #1eabe3;\n  color: #fff;\n  font-weight: bold;\n  padding: 7px;\n  width: 250px;\n}\n\n.list .col-md-12 .info .imageDate .dateHolder .time {\n  float: right;\n}\n\n.list .col-md-12 .info .imageDate .mainImg {\n  background-color: #bbb;\n  float: left;\n  margin-right: 15px;\n  width: 250px;\n}\n\n.list .col-md-12 .info .title {\n  padding-top: 7px;\n  position: relative;\n}\n\n.list .col-md-12 .info .title h3 {\n  margin: 0px 0px 7px;\n  padding-top: 3px;\n  position: relative;\n}\n\n.list .col-md-12 .info .title .more {\n  float: right;\n  padding: 7px;\n}\n\n.list .col-md-12.alert {\n  margin-bottom: 20px;\n  padding: 15px;\n}\n\n.actionHolder {\n  margin-top: 1rem;\n  overflow: hidden;\n  width: 100%;\n}\n\n/*\n* Spinner for all launch buttons on the list, outside of the slide down.\n*/\n.actionHolder .spinner {\n  float: left;\n  margin: 16px 45px 16px 62px;\n}\n\n/* more link */\n.actionHolder .more {\n  float: left;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n/*Start Manager list view */\n\n#assignmentCourseList .description.long {\n  overflow: hidden;\n  white-space: normal;\n  text-overflow: ellipsis;\n}\n\n/* action button css */\n#assignmentCourseList .remove {\n  font-size: 14px;\n  color: black;\n  text-decoration: underline;\n}\n\n/* action button css */\n#assignmentCourseList .removeInactive {\n  font-size: 14px;\n  color: lightgrey;\n  cursor: default;\n}\n\n/* action button css */\n#assignmentCourseList .removeInactive:hover {\n  cursor: default;\n}\n\n#assignmentCourseList .edit {\n  margin-left: 0px;\n  float: left;\n  padding-left: 2px;\n  cursor: pointer;\n}\n\n#assignmentCourseList .assignmentActions {\n  display: flex;\n  margin: 0px 0px;\n}\n\n#assignmentCourseList .managerDate {\n  float: left;\n  font-size: 14px;\n  font-weight: bold;\n  padding-bottom: 1.5rem;\n  padding-right: 2.5rem;\n}\n\n#assignmentCourseList .managerDatePicker {\n  /*width: 250px;*/\n  margin-bottom: 10px;\n}\n\n#assignmentCourseList .btn-default {\n  float: left;\n  margin-right: 15px;\n}\n\n#assignmentCourseList .hideOnListPages {\n  display: none;\n}\n\n#assignmentCourseList .slideDownMeta {\n  padding-top: 0rem !important;\n}\n\n#assignmentCourseList .courseGroupIcon {\n  margin-left: 2rem !important;\n}\n\n/* View Resources start */\n.launchBtnResources {\n  margin-right: 4px !important;\n}\n\n#assignmentCourseList #viewResources .body {\n  overflow: hidden;\n  padding: 5px;\n  padding-left: 10px;\n}\n\n/* View Resources end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
